import axios from "axios";
// import { getToken } from "./auth";
import { getLogin,  } from "@/api/app"
import router from "../router/index"
import store from '../store';
// 创建axios

const server = axios.create({
    // baseURL: "http://baixin.xxzcloud.com",
    // baseURL:"https://admin.gzbxpaper.com",//配置请求的公共前缀
    baseURL: process.env.VUE_APP_API_BASE_URL || "",//配置请求的公共前缀
    timeout: 10000,
    headers:{
        'server':'1',
        'device':'pc',
    }
})

export const baseURL = server.defaults.baseURL;

/* 请求拦截器 + 相应拦截器  */
server.interceptors.request.use((config) => {
    // 动态设置token和语言，确保每次请求都是最新的
    config.headers['think-lang'] = window.localStorage.getItem('language')=='en'?'en':'zh-cn';
    config.headers['ba-user-token'] = window.localStorage.getItem('token') || '';
    return config

})

/* 
  统一处理相应的
*/
server.interceptors.response.use(async (res) => {

    /* 成功回来之后，把数据给到之前执行的  */
    
    // console.log(res);
    // if(res.status != 200){
    //     this.$message.error('出错啦！');
    // }
    if(res.data.code!=1){

        if(res.data.code == 303 || res.data.code == 409){
            console.log(window.localStorage.getItem('user_remember'));
            if(window.localStorage.getItem('user_remember') == 'true'){
                let params = {
                    mobile:window.localStorage.getItem("user_mobile"),
                    password:window.localStorage.getItem("user_pwd"),
                };
                let {data} = await getLogin(params);
                if(data.code == 1){
                    console.log('登录',data.data);
            
                    let userinfo = data.data.userinfo;
                    let token = data.data.userinfo.token;
                    window.localStorage.setItem("userinfo", JSON.stringify(userinfo));
                    window.localStorage.setItem("token", token);
                    store.commit('setUserInfo', userinfo);
                    store.commit('setToken', token);
                    location.reload();
                }
            }else{
                window.localStorage.removeItem('token');
                window.localStorage.removeItem('userinfo');
                setTimeout(()=>{
                    router.push({
                        path: "/Login",
                    })
                },1200)
            }
        }

    }

    return res

})



export default server